import { Link } from "react-router-dom";
import { DISPLAY_LANG } from "../../../config";

export default function AccountBtns({ btns }) {
    return (
        <div className="account-buttons flex-center">
            {btns?.map(elem => (
                <Link to={elem.link} key={elem.id} className="btn">
                    {elem.label[DISPLAY_LANG]}
                </Link>
            ))}
        </div>
    )
}
